import parser from 'html-react-parser';

export default function parse(html) {
  return html ? parser(html) : '';
}
